<template>
  <div class="w-full">
    <label class="mb-1 text-black">
      加入更多客製化選項
    </label>
    <div class="add-others" @click="show = !show">
      <span class="text-gray-300">
        選擇客製化選項
      </span>
      <i :class="[show ? 'icon-up-chevron text-blue-500' : 'icon-down-chevron']" />
    </div>
    <div v-if="show" class="mt-2">
      <div class="custom-items">
        <label
          v-for="option in options"
          :key="`add-other-options-${option.index}`"
          class="border-b border-blue-100 cursor-pointer flex flex-col p-2"
        >
          <div class="flex items-center mb-1 overflow-hidden w-full">
            <section class="flex items-center max-w-[25%] min-w-[25%] mr-2 truncate w-1/4">
              <b-checkbox v-model="selectedIndexes" :native-value="option.index" />
              <label :title="option.name" class="text-black truncate">
                {{ option.name }}
              </label>
            </section>
            <div class="flex items-center truncate w-3/4">
              <section
                v-for="item in option.items"
                :key="`option-${option.index}-item-${item.index}`"
                class="option-item"
              >
                <span>
                  {{ item.name }}
                </span>
                <span v-if="item.price">
                  {{ item.price | commaFormat | priceFormat }}
                </span>
              </section>
            </div>
          </div>
          <span class="ml-8 text-gray-300 text-xs">
            {{ getOptionRulesWithNote(option.rules, option.storeNote) }}
          </span>
        </label>
        <w-button
          class="cursor-pointer mx-4 my-2 px-4 py-2"
          color-type="secondary"
          size="sm"
          type="link"
          @click="$emit('toggle-option-create-mode', true)"
        >
          <i class="icon-plus mr-2" />
          <span>新增客製化選項</span>
        </w-button>
      </div>
      <div class="flex items-center justify-end">
        <w-button :disabled="!options.length" size="sm" @click="onAddOptions">
          確定
        </w-button>
      </div>
    </div>
  </div>
</template>

<script>
import MenuItemOptionsSelector from './MenuItemOptionsSelector';

export default MenuItemOptionsSelector;
</script>

<style lang="scss" scoped>
@import 'MenuItemOptionsSelector';
</style>
